
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[blog_cat_slug]",
      function () {
        return require("private-next-pages/blog/category/[blog_cat_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[blog_cat_slug]"])
      });
    }
  